let api_host, api_host_new, hostname, media_photo_host, product_photo_host, sentry_dsn, sentry_dist, tawk_id
import {logger} from '@bitstillery/common/app'

if (process.env.BUN_ENV === 'staging') {
    hostname = 'staging.v5.springtimegroup.nl'
    media_photo_host = `https://media.${hostname}`
    product_photo_host = `https://photos.${hostname}`
    sentry_dsn = process.env.MSI_SENTRY_DSN
    tawk_id = process.env.MSI_TAWK_ID
    sentry_dist = `${process.env.MSI_SENTRY_DIST}-${process.env.BUN_ENV}` // Portal-a2bc-staging or discover-msi-production
} else if (process.env.BUN_ENV === 'production') {
    hostname = 'movingspirits.nl'
    media_photo_host = `https://media.${hostname}`
    product_photo_host = `https://photos.${hostname}`
    sentry_dsn = process.env.MSI_SENTRY_DSN
    tawk_id = process.env.MSI_TAWK_ID
    sentry_dist = `${process.env.MSI_SENTRY_DIST}-${process.env.BUN_ENV}` // Portal-a2bc-staging or discover-msi-production
} else {
    hostname = 'portal.localhost'
    media_photo_host = 'http://discover.localhost/api/v2/discover/mock-services/aws/s3-attachments/media'
    product_photo_host = 'http://discover.localhost/api/v2/discover/mock-services/aws/s3-attachments/product_photos'
    sentry_dsn = process.env.MSI_TEST_SENTRY ? process.env.MSI_SENTRY_DSN : ''
    tawk_id = process.env.MSI_TEST_TAWK ? process.env.MSI_TAWK_ID : ''
}

// During SSR, construct absolute URLs using hostname since Request() requires absolute URLs
// In browser, use relative URLs which work fine with window.location.origin
if (globalThis.__SSR_MODE__) {
    if (['staging', 'production'].includes(process.env.BUN_ENV)) {
        api_host = `http://web-back-portal:8080`
        api_host_new = `http://fact2server:9022`
    } else {
        api_host = `http://${hostname}/api/v1`
        api_host_new = `http://${hostname}/api/v2`
    }
} else {
    // Browser mode: use relative URLs
    api_host = '/api/v1'
    api_host_new = '/api/v2'
}
logger.info(`api_host: ${api_host}`)
logger.info(`api_host_new: ${api_host_new}`)

export const config = {
    account_name: process.env.MSI_TITLE,
    api_host,
    api_host_new,
    env: process.env.BUN_ENV,
    hostname,
    media_photo_host,
    product_photo_host,
    sentry_dist,
    sentry_dsn,
    tawk_id,
    websiteUrl: process.env.MSI_WEBSITE,
}
